export enum EmpresaFormaPagamentoTipo {
    Catalogo = 1,
}

export enum EmpresaHorarioFuncionamentoTipo {
    Catalogo = 1,
}

export enum EmpresaHorarioFuncionamentoDiaSemana {
    Domingo = 0,
    Segunda = 1,
    Terca = 2,
    Quarta = 3,
    Quinta = 4,
    Sexta = 5,
    Sabado = 6,
}

export enum EmpresaHorarioFuncionamentoTimezone {
    Noronha = 'America/Noronha',
    SaoPaulo = 'America/Sao_Paulo',
    Manaus = 'America/Manaus',
    RioBranco = 'America/Rio_Branco',
}

export enum EmpresaSlugCatalogoTipoUso {
    /** 1 = Somente visualização dos produtos */
    SomenteVisualizacao = 1,
    /** 2 = Visualização dos produtos, realização de pedidos e compartilhamento no WhatsApp */
    VisualizacaoPedidoCompartilhamento = 2,
    /** 3 = Visualização dos produtos, realização de pedidos e checkout de vendas */
    VisualizacaoPedidoCheckout = 3,
}

export enum EmpresaSlugCatalogoExibirPreco {
    NaoExibir = 1,
    ExibirPrecoProduto = 2,
    ExibirPrecoTabela = 3,
    ExibirPrecoClientesLogados = 4,
}

export enum EmpresaSlugNotificarEmpresa {
    NaoNotificar = 1,
    NotificarEmailWhatsapp = 2,
    NotificarWhatsapp = 3,
    NotificarEmail = 4,
}

export enum EmpresaSlugCatalogoTipoRecebimento {
    EntregaRetirada = 1,
    Retirada = 2,
    Entrega = 3,
}

export enum EmpresaSlugCatalogoCompraClienteTipo {
    Todos = 1,
    CPF = 2,
    CNPJ = 3,
}
